
import { User, Mail, Phone, FileText, Eye, Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Contact } from "./types";

interface ContactCardProps {
  contact: Contact;
  onView: (contact: Contact) => void;
  onEdit: (contact: Contact) => void;
}

export const ContactCard = ({ contact, onView, onEdit }: ContactCardProps) => {
  const fullName = `${contact.first_name} ${contact.last_name || ''}`.trim();
  
  return (
    <div className="border rounded-sm p-4 h-full">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3">
          <div className="bg-gray-100 rounded-sm p-2">
            <User className="h-6 w-6 text-gray-500" />
          </div>
          <div className="flex-1">
            <h4 className="font-medium">{fullName}</h4>
            {contact.function && (
              <p className="text-sm text-gray-600">{contact.function}</p>
            )}
          </div>
        </div>
        
        <div className="flex space-x-2">
          <Button 
            variant="outline" 
            size="sm" 
            className="h-8 w-8 p-0" 
            onClick={() => onView(contact)}
          >
            <Eye className="h-4 w-4" />
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            className="h-8 w-8 p-0"
            onClick={() => onEdit(contact)}
          >
            <Edit className="h-4 w-4" />
          </Button>
        </div>
      </div>
      
      <div className="mt-3 space-y-2">
        {contact.email && (
          <div className="flex items-center text-sm">
            <Mail className="h-4 w-4 text-gray-400 mr-2" />
            <a href={`mailto:${contact.email}`} className="text-digger-blue hover:underline">
              {contact.email}
            </a>
          </div>
        )}
        
        {contact.phone && (
          <div className="flex items-center text-sm">
            <Phone className="h-4 w-4 text-gray-400 mr-2" />
            <a href={`tel:${contact.phone}`} className="text-digger-blue hover:underline">
              {contact.phone}
            </a>
          </div>
        )}
      </div>
      
      {contact.notes && (
        <div className="mt-3 text-sm">
          <div className="flex items-center text-gray-600 mb-1">
            <FileText className="h-4 w-4 mr-2" />
            <span>Notes</span>
          </div>
          <p className="text-gray-700 line-clamp-2">{contact.notes}</p>
        </div>
      )}
    </div>
  );
};
